module.exports = __webpack_public_path__ + "img/Done.4ab8cb20.svg";